const instantDownload = (file, name = "") => {
  var element = document.createElement("a");

  element.setAttribute(
    "href",
    "data:application/octet-stream;base64," +
      encodeURIComponent(
        file.substring(file.split("").findIndex((e) => e === ",") + 1)
      )
  );

  element.setAttribute("download", name);

  element.style.display = "none";
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
};

export default instantDownload;
